var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme},[(_vm.isAuthenticated && !_vm.isRouteWithHiddenNav)?_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('new-navigation-wrap',[_c('router-view')],1)],1):_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }